import { useState, useCallback } from "react";
import useWexClient from "./Clients/wexClient,";

export const useCabin = () => {
  const { getAdjustersOnRoad, getPendingFoliosBySupervisor } = useWexClient();

  const [routesData, setRoutesData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [loading, setLoading] = useState(false);

  /**
   * 🔵 Ajustadores en ruta
   */
  const fetchAdjustersOnRoad = useCallback(
    async (idSupervisor) => {
      try {
        setLoading(true);

        const response = await getAdjustersOnRoad(idSupervisor);
        // console.log("________EN RUTA______________", response);
        const raw = response?.data || [];

        // Función helper para dar formato
        const formatDate = (dateString) => {
          if (!dateString) return "-";

          const date = new Date(dateString);
          // Revisa si es una fecha válida
          if (isNaN(date.getTime())) return "-";

          return new Intl.DateTimeFormat("es-MX", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true, // Pon false si prefieres formato 24 horas (ej. 18:30)
          }).format(date);
        };

        // 🔥 Normalización (MUY IMPORTANTE)
        const mapped = raw.map((item) => ({
          id: item._id, // este es el _idHeader
          // Se pinta
          agentDisplay: `${item.agent?.profile?.alias || " DESC "} (${item.agent?.user || ""})`,
          folio: item.externalFolio || "Sin folio",
          // 🔥 NO se pinta pero necesita
          agentId: item.agent?._id,
          //checkin habilitado?
          enabledCheckin: item.enabledCheckin,
          // cuando acpeto?
          acceptedDate: formatDate(item.acceptDt),
          // opcional por si luego necesito todo
          raw: item,
        }));

        setRoutesData(mapped);
      } catch (error) {
        console.error("Error fetchAdjustersOnRoad:", error);
        setRoutesData([]);
      } finally {
        setLoading(false);
      }
    },
    [getAdjustersOnRoad],
  );

  /**
   *  Casos pendientes por Supervisor
   */
  const fetchPendingFoliosBySupervisor = useCallback(
    async (supervisorId) => {
      try {
        setLoading(true);

        const response = await getPendingFoliosBySupervisor(supervisorId);

        const raw = response?.data || [];
        //console.log("====RAW===!!!", raw);
        const mapped = raw.map((item) => ({
          id: item.idHeader,

          // 🔹 Para UI rápida
          folio: item.folio,
          status: item.status,
          statusText: item.statusText,

          client: item.incidentData?.name || "Sin nombre",
          phone: item.incidentData?.phone || "N/A",
          externalFolio: item.incidentData?.externalFolio || "-",
          location: item.incidentData?.location || "",
          comments: item.incidentData?.comments || item.comments || "",

          createdAt: item.createdAt,
          classification: item.classification,
          assignedAgent: item.assignedAgent || "-",

          // 🔥 IMPORTANTE → objeto completo para acciones futuras
          raw: item,
        }));

        setPendingData(mapped);
      } catch (error) {
        console.error("Error fetchPendingFoliosBySupervisor:", error);
        setPendingData([]);
      } finally {
        setLoading(false);
      }
    },
    [getPendingFoliosBySupervisor],
  );

  /**
   *  Fetch general (Solo usa idSupervisor)
   */
  const fetchCabinData = useCallback(
    async (idSupervisor) => {
      if (!idSupervisor) return;

      await Promise.all([
        fetchAdjustersOnRoad(idSupervisor),
        fetchPendingFoliosBySupervisor(idSupervisor),
      ]);
    },
    [fetchAdjustersOnRoad, fetchPendingFoliosBySupervisor],
  );

  return {
    routesData,
    pendingData,
    loading,
    fetchCabinData,
    fetchAdjustersOnRoad,
    fetchPendingFoliosBySupervisor,
  };
};
